"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var configuration_1 = require("../configuration");
var ToolTipProvider = (function () {
    function ToolTipProvider(font) {
        this._font = font;
    }
    ToolTipProvider.prototype.setGrid = function (grid) {
        this._grid = grid;
    };
    ToolTipProvider.prototype.setColumnSet = function (columnSet) {
        this._columnSet = columnSet;
    };
    ToolTipProvider.prototype.setRows = function (rows) {
        this._rows = rows;
    };
    ToolTipProvider.prototype.assignTooltip = function () {
        var _this = this;
        if (this._grid === undefined) {
            configuration_1.PlanConfiguration.logger.warn("Grid missing!");
            return;
        }
        if (this._columnSet === undefined) {
            configuration_1.PlanConfiguration.logger.warn("ColumnSet missing!");
            return;
        }
        if (this._font === undefined) {
            configuration_1.PlanConfiguration.logger.warn("font missing!");
            return;
        }
        if (this._rows === undefined) {
            configuration_1.PlanConfiguration.logger.warn("rows missing!");
            return;
        }
        this._grid.getTooltip = function (target, x, y) {
            try {
                if (!target || !target.cellByLocation) {
                    return;
                }
                var cell = target.cellByLocation(x, y);
                if (!cell) {
                    return;
                }
                var columnConfig = _this._columnSet.columns[cell[1]];
                var mouseHoverDataPath = _.get(columnConfig, "mouseHoverDataPath");
                var row = _this._rows[cell[0]];
                if (mouseHoverDataPath) {
                    var value = _.get(row, mouseHoverDataPath.toString());
                    if (value && value !== "") {
                        return _this.createTooltip(value.toString());
                    }
                    else {
                        var emptyText = _.get(columnConfig, "mouseHoverTextOnEmpty");
                        if (emptyText) {
                            return _this.createTooltip(emptyText.toString());
                        }
                    }
                }
            }
            catch (error) {
                _.noop();
            }
        };
        return undefined;
    };
    ToolTipProvider.prototype.createTooltip = function (value) {
        var thePopup = new zebra.ui.Panel();
        thePopup.setBackground(configuration_1.PlanConfiguration.hoverPopupBackgroundColor);
        thePopup.setBorder(new zebra.ui.Border(configuration_1.PlanConfiguration.hoverPopupBorderColor, 1, configuration_1.PlanConfiguration.hoverPopupBorderRadius));
        thePopup.setPadding(configuration_1.PlanConfiguration.hoverPopupPadding);
        thePopup.setLayout(new zebra.layout.ListLayout());
        var singleBoxes = this.createSplittedBoxes(value, configuration_1.PlanConfiguration.hoverPopupWidth);
        singleBoxes.boxes.forEach(function (box) {
            thePopup.add(box);
        });
        var paddingFactor = 2;
        thePopup.setPreferredSize(singleBoxes.width + (paddingFactor * configuration_1.PlanConfiguration.hoverPopupPadding), singleBoxes.height + (paddingFactor * configuration_1.PlanConfiguration.hoverPopupPadding));
        return thePopup;
    };
    ToolTipProvider.prototype.createSplittedBoxes = function (input, maxWidth) {
        var _this = this;
        var split = input.split(" ");
        var lineBoxes = new Array();
        var wordBoxes = new Array();
        var widthSum = 0;
        var height = 0;
        var width = 0;
        lineBoxes.push(ToolTipProvider.getFlowPanel());
        split.forEach(function (item) {
            var label = new zebra.ui.Label(item);
            label.setPadding(0, 0, 0, _this.getSpaceWidth());
            label.setFont(_this._font);
            label.setColor(configuration_1.PlanConfiguration.hoverPopupFontColor);
            var size = label.getPreferredSize();
            height = size.height;
            widthSum += size.width;
            if (widthSum >= maxWidth) {
                wordBoxes.forEach(function (wordBox) {
                    lineBoxes[lineBoxes.length - 1].add(wordBox);
                });
                lineBoxes.push(ToolTipProvider.getFlowPanel());
                wordBoxes = new Array();
                width = Math.max(width, (widthSum - size.width));
                widthSum = size.width;
                wordBoxes.push(label);
            }
            else {
                wordBoxes.push(label);
            }
        });
        wordBoxes.forEach(function (wordBox) {
            lineBoxes[lineBoxes.length - 1].add(wordBox);
        });
        width = Math.max(width, (lineBoxes[lineBoxes.length - 1].getPreferredSize().width));
        var totalHeight = (height * (lineBoxes.length));
        return { boxes: lineBoxes, width: width, height: totalHeight };
    };
    ToolTipProvider.getFlowPanel = function () {
        var result = new zebra.ui.Panel();
        result.setLayout(new zebra.layout.FlowLayout());
        return result;
    };
    ToolTipProvider.prototype.getSpaceWidth = function () {
        var label = new zebra.ui.Label(" ");
        label.setFont(this._font);
        return label.getPreferredSize().width;
    };
    return ToolTipProvider;
}());
exports.ToolTipProvider = ToolTipProvider;
//# sourceMappingURL=toolTipProvider.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/tooltips/ToolTipProvider.js
// module id = 78
// module chunks = 0